import { isSpanContextValid, trace } from '@opentelemetry/api';
/**
 * Build a W3C `traceparent` header value from the currently active span,
 * or return `null` if there isn't one.
 *
 * Format (`version-traceId-parentId-flags`):
 *   00-0af7651916cd43dd8448eb211c80319c-b7ad6b7169203331-01
 *
 * Reading the active span via `@opentelemetry/api` rather than running a
 * propagator keeps the dependency to a single package: any OTel SDK
 * configured by the host will populate the active context; without one,
 * `getActiveSpan()` returns `undefined` and we omit the header.
 */
export function traceparent() {
    const span = trace.getActiveSpan();
    if (!span)
        return null;
    const ctx = span.spanContext();
    if (!isSpanContextValid(ctx))
        return null;
    const flags = ctx.traceFlags.toString(16).padStart(2, '0');
    return `00-${ctx.traceId}-${ctx.spanId}-${flags}`;
}
//# sourceMappingURL=trace.js.map